"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalProductApi = require("@/api/dentalProductApi");
var _dashboard = require("@/api/dashboard");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _clinicBinding = _interopRequireDefault(require("./clinicBinding"));
var _supplierBinding = _interopRequireDefault(require("./supplierBinding"));
var _distributorBinding = _interopRequireDefault(require("./distributorBinding"));
var _uploadPicture = _interopRequireDefault(require("@/components/uploadPicture"));
var _previewImg = require("@/components/previewImg");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DentalProductList',
  components: {
    Editor: _Tinymce.default,
    ClinicBinding: _clinicBinding.default,
    SupplierBinding: _supplierBinding.default,
    DistributorBinding: _distributorBinding.default,
    uploadPicture: _uploadPicture.default,
    SimpleImageViewer: _previewImg.SimpleImageViewer
  },
  data: function data() {
    return {
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      activeName: 'first',
      listLoading: false,
      searchForm: {
        page: 1,
        limit: 10,
        keyword: '',
        supplierId: '',
        status: ''
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加套餐商品',
      activeStep: 0,
      productForm: {
        id: null,
        productName: '',
        price: '',
        originalPrice: '',
        costPrice: '',
        materialPrice: '',
        examPrice: '',
        supplierId: '',
        supplierName: '',
        status: 1,
        syncStatus: 1,
        imageList: [],
        tagList: [],
        description: '',
        customerIdList: [],
        // 存储选中的分销商ID列表
        remark: ''
      },
      previewConfig: {
        visible: false,
        urlList: [],
        index: 0
      },
      rules: {
        productName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入售价',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入售价'));
            } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value.toString())) {
              callback(new Error('售价必须为数字，最多两位小数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        originalPrice: [{
          required: true,
          message: '请输入原价',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入原价'));
            } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value.toString())) {
              callback(new Error('原价必须为数字，最多两位小数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        materialPrice: [{
          required: true,
          message: '请输入材料费',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入材料费'));
            } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value.toString())) {
              callback(new Error('材料费必须为数字，最多两位小数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        examPrice: [{
          required: true,
          message: '请输入检查费',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入检查费'));
            } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value.toString())) {
              callback(new Error('检查费必须为数字，最多两位小数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        supplierId: [{
          required: true,
          message: '请选择供应商',
          trigger: 'change'
        }]
      },
      supplierOptions: [],
      supplierLoading: false,
      customerOptions: [],
      distributorOptions: [],
      tagOptions: ['医疗', '口腔', '牙科', '美容', '正畸'],
      clinicBindingVisible: false,
      currentProductId: null,
      selectedClinicIds: [],
      supplierBindingVisible: false,
      selectedSupplierIds: [],
      distributorBindingVisible: false,
      selectedDistributorIds: [],
      inputVisible: false,
      inputValue: '',
      detailDialogVisible: false,
      detailLoading: false,
      detailData: {},
      savedDescription: '',
      submitLoading: false,
      viewMode: localStorage.getItem('dentalProductViewMode') || 'list'
    };
  },
  created: function created() {
    this.getList();
    this.getSuppliers();
    this.getDistributors();
  },
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        keyword: this.searchForm.keyword,
        supplierId: this.searchForm.supplierId,
        status: this.searchForm.status
      };
      (0, _dentalProductApi.getProductList)(params).then(function (response) {
        // 检查 response 的数据结构并正确解析
        if (response && response.code === 200) {
          // 如果 response 包含 code 和 data，则使用 response.data
          _this2.tableData = response.data.list || [];
          _this2.total = response.data.total || 0;
        } else if (response && response.list) {
          // 如果 response 直接包含 list 和 total，则直接使用
          _this2.tableData = response.list || [];
          _this2.total = response.total || 0;
        } else if (Array.isArray(response)) {
          // 如果 response 是数组，则直接使用
          _this2.tableData = response;
          _this2.total = response.length;
        } else {
          // 兜底处理
          _this2.tableData = [];
          _this2.total = 0;
          console.error('无法解析返回的数据结构:', response);
        }

        // 调试输出
        console.log('tableData:', _this2.tableData);
        console.log('total:', _this2.total);
      }).catch(function (error) {
        console.error('获取列表数据失败:', error);
        _this2.tableData = [];
        _this2.total = 0;
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    // 获取供应商列表
    getSuppliers: function getSuppliers() {
      var _this3 = this;
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierLoading = true;
      (0, _dentalProductApi.getSupplierList)({
        keyword: query
      }).then(function (res) {
        _this3.supplierOptions = res || [];
        _this3.supplierLoading = false;
      }).catch(function () {
        _this3.supplierLoading = false;
      });
    },
    // 远程搜索供应商
    remoteSearchSupplier: function remoteSearchSupplier(query) {
      var _this4 = this;
      if (query) {
        this.supplierLoading = true;
        (0, _dentalProductApi.getSupplierList)({
          keyword: query
        }).then(function (res) {
          _this4.supplierOptions = res || [];
          _this4.supplierLoading = false;
        }).catch(function () {
          _this4.supplierLoading = false;
        });
      } else {
        this.getSuppliers();
      }
    },
    // 供应商选择变更
    handleSupplierChange: function handleSupplierChange(value) {
      var supplier = this.supplierOptions.find(function (item) {
        return item.id === value;
      });
      if (supplier) {
        this.productForm.supplierName = supplier.supplierName;
      }
    },
    // 获取客户列表
    getCustomers: function getCustomers() {
      var _this5 = this;
      (0, _dentalProductApi.getCustomerList)().then(function (res) {
        _this5.customerOptions = res || [];
      });
    },
    // 获取分销商列表
    getDistributors: function getDistributors() {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        (0, _dashboard.customersListApi)().then(function (res) {
          if (res && Array.isArray(res)) {
            // 确保每个分销商对象的id字段是数字类型
            _this6.distributorOptions = res.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                id: Number(item.id)
              });
            });
          } else {
            _this6.distributorOptions = [];
          }
          console.log('已加载分销商列表:', _this6.distributorOptions);
          resolve(_this6.distributorOptions);
        }).catch(function (err) {
          console.error('获取分销商列表失败:', err);
          reject(err);
        });
      });
    },
    // 处理搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm = {
        page: 1,
        limit: 10,
        keyword: '',
        supplierId: '',
        status: ''
      };
      this.getList();
    },
    // 处理分页大小变化
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    // 处理页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    // 处理添加
    handleAdd: function handleAdd() {
      var _this7 = this;
      this.dialogTitle = '添加套餐商品';
      // 先重置表单数据，确保清除上一次编辑的记录
      this.productForm = {
        id: null,
        productName: '',
        price: '',
        originalPrice: '',
        costPrice: '',
        materialPrice: '',
        examPrice: '',
        supplierId: '',
        supplierName: '',
        status: 1,
        syncStatus: 1,
        imageList: [],
        tagList: [],
        description: '',
        customerIdList: [],
        remark: ''
      };
      // 清空保存的描述内容
      this.savedDescription = '';
      this.activeStep = 0;
      this.dialogVisible = true;

      // 确保表单验证状态也被重置
      this.$nextTick(function () {
        if (_this7.$refs.productForm) {
          _this7.$refs.productForm.clearValidate();
        }
      });
    },
    // 处理编辑
    handleEdit: function handleEdit(row) {
      var _this8 = this;
      this.dialogTitle = '编辑套餐商品';
      this.resetForm();
      this.activeStep = 0;
      this.dialogVisible = true;

      // 显示加载中
      this.listLoading = true;

      // 从API获取最新的商品数据
      (0, _dentalProductApi.getProductDetail)(row.id).then(function (response) {
        if (!response) {
          _this8.$message.error('获取商品详情失败');
          return;
        }

        // 使用API返回的最新数据
        var productData = response;
        _this8.productForm = {
          id: productData.id,
          productName: productData.productName,
          price: productData.price !== null && productData.price !== undefined ? productData.price.toString() : '',
          originalPrice: productData.originalPrice !== null && productData.originalPrice !== undefined ? productData.originalPrice.toString() : '',
          costPrice: productData.costPrice !== null && productData.costPrice !== undefined ? productData.costPrice.toString() : '',
          materialPrice: productData.materialPrice !== null && productData.materialPrice !== undefined ? productData.materialPrice.toString() : '',
          examPrice: productData.examPrice !== null && productData.examPrice !== undefined ? productData.examPrice.toString() : '',
          supplierId: productData.supplierId,
          supplierName: productData.supplierName,
          status: productData.status !== null && productData.status !== undefined ? productData.status : 1,
          syncStatus: productData.syncStatus !== null && productData.syncStatus !== undefined ? productData.syncStatus : 1,
          description: productData.description || '',
          remark: productData.remark || ''
        };

        // 处理图片列表
        if (typeof productData.imageList === 'string') {
          _this8.productForm.imageList = productData.imageList.split(',').filter(function (url) {
            return url && url.trim() !== '';
          });
        } else if (Array.isArray(productData.imageList)) {
          _this8.productForm.imageList = _toConsumableArray(productData.imageList);
        } else {
          _this8.productForm.imageList = [];
        }

        // 处理标签列表
        if (typeof productData.tagList === 'string') {
          _this8.productForm.tagList = productData.tagList.split(',').filter(function (tag) {
            return tag && tag.trim() !== '';
          });
        } else if (Array.isArray(productData.tagList)) {
          _this8.productForm.tagList = _toConsumableArray(productData.tagList);
        } else {
          _this8.productForm.tagList = [];
        }

        // 处理客户ID列表
        if (typeof productData.customerIdList === 'string') {
          _this8.productForm.customerIdList = productData.customerIdList.split(',').map(function (id) {
            return Number(id);
          }).filter(function (id) {
            return !isNaN(id);
          });
        } else if (Array.isArray(productData.customerIdList)) {
          // 确保所有ID都是数字类型
          _this8.productForm.customerIdList = productData.customerIdList.map(function (id) {
            return Number(id);
          }).filter(function (id) {
            return !isNaN(id);
          });
        } else {
          _this8.productForm.customerIdList = [];
        }
        console.log('初始化后的customerIdList:', _this8.productForm.customerIdList);

        // 如果有描述内容，保存到savedDescription
        if (productData.description) {
          _this8.savedDescription = productData.description;
        }
      }).catch(function (error) {
        console.error('获取商品详情失败:', error);
        _this8.$message.error('获取商品详情失败，请重试');
      }).finally(function () {
        _this8.listLoading = false;
      });

      // 确保分销商列表数据已加载
      if (this.distributorOptions.length === 0) {
        this.getDistributors();
      }
    },
    // 从详情页面编辑
    handleEditFromDetail: function handleEditFromDetail() {
      var _this9 = this;
      var productId = this.productDetail.id;
      this.detailDialogVisible = false;

      // 延迟一下，确保详情对话框已关闭
      setTimeout(function () {
        _this9.dialogTitle = '编辑套餐商品';
        _this9.resetForm();
        _this9.activeStep = 0;
        _this9.dialogVisible = true;

        // 显示加载中
        _this9.listLoading = true;

        // 从API获取最新的商品数据
        (0, _dentalProductApi.getProductDetail)(productId).then(function (response) {
          if (!response) {
            _this9.$message.error('获取商品详情失败');
            return;
          }

          // 使用API返回的最新数据
          var productData = response;
          _this9.productForm = {
            id: productData.id,
            productName: productData.productName,
            price: productData.price !== null && productData.price !== undefined ? productData.price.toString() : '',
            originalPrice: productData.originalPrice !== null && productData.originalPrice !== undefined ? productData.originalPrice.toString() : '',
            costPrice: productData.costPrice !== null && productData.costPrice !== undefined ? productData.costPrice.toString() : '',
            materialPrice: productData.materialPrice !== null && productData.materialPrice !== undefined ? productData.materialPrice.toString() : '',
            examPrice: productData.examPrice !== null && productData.examPrice !== undefined ? productData.examPrice.toString() : '',
            supplierId: productData.supplierId,
            supplierName: productData.supplierName,
            status: productData.status !== null && productData.status !== undefined ? productData.status : 1,
            syncStatus: productData.syncStatus !== null && productData.syncStatus !== undefined ? productData.syncStatus : 1,
            description: productData.description || '',
            remark: productData.remark || ''
          };

          // 处理图片列表
          if (typeof productData.imageList === 'string') {
            _this9.productForm.imageList = productData.imageList.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
          } else if (Array.isArray(productData.imageList)) {
            _this9.productForm.imageList = _toConsumableArray(productData.imageList);
          } else {
            _this9.productForm.imageList = [];
          }

          // 处理标签列表
          if (typeof productData.tagList === 'string') {
            _this9.productForm.tagList = productData.tagList.split(',').filter(function (tag) {
              return tag && tag.trim() !== '';
            });
          } else if (Array.isArray(productData.tagList)) {
            _this9.productForm.tagList = _toConsumableArray(productData.tagList);
          } else {
            _this9.productForm.tagList = [];
          }

          // 处理客户ID列表
          if (typeof productData.customerIdList === 'string') {
            _this9.productForm.customerIdList = productData.customerIdList.split(',').map(function (id) {
              return Number(id);
            }).filter(function (id) {
              return !isNaN(id);
            });
          } else if (Array.isArray(productData.customerIdList)) {
            // 确保所有ID都是数字类型
            _this9.productForm.customerIdList = productData.customerIdList.map(function (id) {
              return Number(id);
            }).filter(function (id) {
              return !isNaN(id);
            });
          } else {
            _this9.productForm.customerIdList = [];
          }
          console.log('初始化后的customerIdList:', _this9.productForm.customerIdList);

          // 如果有描述内容，保存到savedDescription
          if (productData.description) {
            _this9.savedDescription = productData.description;
          }
        }).catch(function (error) {
          console.error('获取商品详情失败:', error);
          _this9.$message.error('获取商品详情失败，请重试');
        }).finally(function () {
          _this9.listLoading = false;
        });

        // 确保分销商列表数据已加载
        if (_this9.distributorOptions.length === 0) {
          _this9.getDistributors();
        }
      }, 100);
    },
    // 处理删除
    handleDelete: function handleDelete(row) {
      var _this0 = this;
      this.$confirm('确定要删除该商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dentalProductApi.deleteProduct)(row.id).then(function () {
          _this0.$message.success('删除成功');
          _this0.getList();
        });
      }).catch(function () {});
    },
    // 关闭对话框
    handleDialogClose: function handleDialogClose() {
      this.dialogVisible = false;
      // 清空表单数据，确保下次打开时不会残留
      this.resetForm();
      // 清空步骤
      this.activeStep = 0;
      // 刷新列表数据
      this.getList();
    },
    // 重置表单
    resetForm: function resetForm() {
      var _this1 = this;
      this.productForm = {
        id: null,
        productName: '',
        price: '',
        originalPrice: '',
        costPrice: '',
        materialPrice: '',
        examPrice: '',
        supplierId: '',
        supplierName: '',
        status: 1,
        syncStatus: 1,
        imageList: [],
        tagList: [],
        description: '',
        customerIdList: [],
        remark: ''
      };

      // 重置保存的描述内容
      this.savedDescription = '';

      // 完全重置表单，不保留任何之前的值
      this.$nextTick(function () {
        if (_this1.$refs.productForm) {
          _this1.$refs.productForm.resetFields();
          _this1.$refs.productForm.clearValidate();
        }

        // 如果有富文本编辑器，清空内容
        if (_this1.$refs.descriptionEditor) {
          try {
            _this1.$refs.descriptionEditor.setContent('');
          } catch (e) {
            console.error('重置编辑器内容失败:', e);
          }
        }
      });
    },
    // 上一步
    prevStep: function prevStep() {
      if (this.activeStep > 0) {
        this.activeStep--;
      }
    },
    // 下一步
    nextStep: function nextStep() {
      var _this10 = this;
      // 只有第一步需要表单验证
      if (this.activeStep === 0) {
        this.$refs.productForm.validate(function (valid) {
          if (valid) {
            _this10.activeStep++;
            // 当进入详情信息步骤时，确保富文本编辑器内容正确加载
            if (_this10.activeStep === 1) {
              _this10.$nextTick(function () {
                if (_this10.$refs.descriptionEditor) {
                  // 如果是编辑模式且有保存的描述内容，恢复该内容
                  if (_this10.productForm.id && _this10.savedDescription) {
                    _this10.productForm.description = _this10.savedDescription;
                    try {
                      _this10.$refs.descriptionEditor.setContent(_this10.savedDescription);
                    } catch (e) {
                      console.error('设置编辑器内容失败:', e);
                    }
                  }
                  // 如果是新增模式，确保编辑器是空的
                  else if (!_this10.productForm.id) {
                    try {
                      _this10.$refs.descriptionEditor.setContent('');
                    } catch (e) {
                      console.error('清空编辑器内容失败:', e);
                    }
                  }
                }
              });
            }
          } else {
            _this10.$message.warning('请完善必填信息后再进行下一步');
            return false;
          }
        });
      } else if (this.activeStep < 3) {
        this.activeStep++;
        // 当进入详情信息步骤时，确保富文本编辑器内容正确加载
        if (this.activeStep === 1) {
          this.$nextTick(function () {
            if (_this10.$refs.descriptionEditor) {
              // 如果是编辑模式且有保存的描述内容，恢复该内容
              if (_this10.productForm.id && _this10.savedDescription) {
                _this10.productForm.description = _this10.savedDescription;
                try {
                  _this10.$refs.descriptionEditor.setContent(_this10.savedDescription);
                } catch (e) {
                  console.error('设置编辑器内容失败:', e);
                }
              }
              // 如果是新增模式，确保编辑器是空的
              else if (!_this10.productForm.id) {
                try {
                  _this10.$refs.descriptionEditor.setContent('');
                } catch (e) {
                  console.error('清空编辑器内容失败:', e);
                }
              }
            }
          });
        }
      }
    },
    // 保存当前步骤数据
    saveCurrentStep: function saveCurrentStep(callback) {
      var _this11 = this;
      // 创建提交用的数据对象，确保价格字段被转换为数字
      var formData = _objectSpread(_objectSpread({}, this.productForm), {}, {
        price: this.productForm.price ? parseFloat(this.productForm.price) : 0,
        originalPrice: this.productForm.originalPrice ? parseFloat(this.productForm.originalPrice) : 0,
        costPrice: this.productForm.costPrice ? parseFloat(this.productForm.costPrice) : 0,
        materialPrice: this.productForm.materialPrice ? parseFloat(this.productForm.materialPrice) : 0,
        examPrice: this.productForm.examPrice ? parseFloat(this.productForm.examPrice) : 0
      });

      // 确保使用保存的描述内容（如果有）
      if (this.savedDescription) {
        formData.description = this.savedDescription;
      }

      // 处理图片列表
      if (Array.isArray(this.productForm.imageList) && this.productForm.imageList.length > 0) {
        // 过滤掉任何可能的base64数据
        var urlList = this.productForm.imageList.filter(function (url) {
          if (typeof url === 'string') {
            return !url.startsWith('data:image'); // 过滤掉base64数据
          }
          return false;
        });

        // 转换为后端需要的格式：逗号分隔的URL字符串
        formData.imageList = urlList.join(',');
      } else {
        formData.imageList = '';
      }

      // 处理标签列表，确保是逗号分隔的字符串
      if (Array.isArray(this.productForm.tagList) && this.productForm.tagList.length > 0) {
        formData.tagList = this.productForm.tagList.join(',');
      } else {
        formData.tagList = '';
      }

      // 处理客户ID列表，确保是逗号分隔的字符串
      if (Array.isArray(this.productForm.customerIdList) && this.productForm.customerIdList.length > 0) {
        formData.customerIdList = this.productForm.customerIdList.join(',');
      } else {
        formData.customerIdList = '';
      }

      // 显示保存中状态
      this.submitLoading = true;

      // 调用API保存数据
      (0, _dentalProductApi.saveOrUpdateProduct)(formData).then(function (res) {
        if (res) {
          _this11.$message.success('保存成功');

          // 如果是新增，更新ID
          if (!_this11.productForm.id && res.id) {
            _this11.productForm.id = res.id;
          }

          // 执行回调函数
          if (typeof callback === 'function') {
            callback();
          }
        } else {
          _this11.$message.error('保存失败');
        }
      }).catch(function (error) {
        console.error('保存失败:', error);
        _this11.$message.error('保存失败: ' + (error.message || '未知错误'));
      }).finally(function () {
        _this11.submitLoading = false;
      });
    },
    // 修改提交表单方法
    submitForm: function submitForm() {
      var _this12 = this;
      // 如果当前是第一步，需要先验证表单
      if (this.activeStep === 0) {
        this.$refs.productForm.validate(function (valid) {
          if (valid) {
            _this12.saveCurrentStep(function () {
              // 保存成功后关闭对话框并刷新列表
              _this12.dialogVisible = false;
              _this12.getList();
            });
          } else {
            _this12.$message.warning('请完善必填信息后再提交');
            return false;
          }
        });
      } else {
        this.saveCurrentStep(function () {
          // 保存成功后关闭对话框并刷新列表
          _this12.dialogVisible = false;
          _this12.getList();
        });
      }
    },
    // 删除图片
    handleRemoveImage: function handleRemoveImage(index) {
      var _this13 = this;
      if (index >= 0 && index < this.productForm.imageList.length) {
        var removedUrl = this.productForm.imageList[index];
        this.productForm.imageList.splice(index, 1);
        this.$message.success('图片已删除');
        console.log('Removed image at index', index, ':', removedUrl);

        // 如果是编辑模式，更新图片字段以符合后台要求
        if (this.productForm.id) {
          var formData = {
            id: this.productForm.id,
            imageList: this.productForm.imageList
          };
          // 这里可以选择是否立即提交更新到服务器
          // 由于这是编辑界面，通常在整体提交时才会保存，所以这里不调用API
        }

        // 使用nextTick确保在DOM更新后再强制刷新
        this.$nextTick(function () {
          _this13.$forceUpdate();
        });
      }
    },
    // 检查项目是否被选中
    isItemChecked: function isItemChecked(id) {
      var numId = Number(id);
      return this.productForm.customerIdList.some(function (item) {
        return Number(item) === numId;
      });
    },
    // 处理项目点击
    handleItemClick: function handleItemClick(id) {
      var numId = Number(id);
      var index = this.productForm.customerIdList.findIndex(function (item) {
        return Number(item) === numId;
      });
      if (index === -1) {
        // 未选中，添加到选中列表
        this.productForm.customerIdList.push(numId);
      } else {
        // 已选中，从列表中移除
        this.productForm.customerIdList.splice(index, 1);
      }
      console.log('选中的分销商IDs:', this.productForm.customerIdList);
      // 强制更新视图
      this.$forceUpdate();
    },
    // 处理标签操作
    handleTagClose: function handleTagClose(tag) {
      this.productForm.tagList.splice(this.productForm.tagList.indexOf(tag), 1);
    },
    showTagInput: function showTagInput() {
      var _this14 = this;
      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this14.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleTagInputConfirm: function handleTagInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue && this.productForm.tagList.indexOf(inputValue) === -1) {
        this.productForm.tagList.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    // 处理绑定诊所
    handleBindClinic: function handleBindClinic(row) {
      this.currentProductId = row.id;
      this.selectedClinicIds = row.clinicIds || [];
      this.clinicBindingVisible = true;
    },
    // 处理诊所绑定确认
    handleClinicBindingConfirm: function handleClinicBindingConfirm(clinicIds) {
      var _this15 = this;
      // 调用API保存绑定关系
      var data = {
        productId: this.currentProductId,
        clinicIds: clinicIds
      };
      (0, _dentalProductApi.bindProductToClinics)(data).then(function () {
        _this15.$message.success('绑定诊所成功');
        _this15.getList();
      }).catch(function (error) {
        _this15.$message.error('绑定诊所失败: ' + error.message);
      });
    },
    // 处理绑定供应商
    handleBindSupplier: function handleBindSupplier(row) {
      this.currentProductId = row.id;
      this.selectedSupplierIds = row.supplierIds || [];
      this.supplierBindingVisible = true;
    },
    // 处理供应商绑定确认
    handleSupplierBindingConfirm: function handleSupplierBindingConfirm(supplierIds) {
      var _this16 = this;
      // 调用API保存绑定关系
      var data = {
        productId: this.currentProductId,
        supplierIds: supplierIds
      };
      (0, _dentalProductApi.bindProductToSuppliers)(data).then(function () {
        _this16.$message.success('绑定供应商成功');
        _this16.getList();
      }).catch(function (error) {
        _this16.$message.error('绑定供应商失败: ' + error.message);
      });
    },
    // 处理绑定分销商
    handleBindDistributor: function handleBindDistributor(row) {
      this.currentProductId = row.id;
      this.selectedDistributorIds = row.customerIdList || [];
      this.distributorBindingVisible = true;
    },
    // 处理分销商绑定确认
    handleDistributorBindingConfirm: function handleDistributorBindingConfirm(distributorIds) {
      var _this17 = this;
      // 调用API保存绑定关系
      var data = {
        productId: this.currentProductId,
        customerIds: distributorIds
      };
      (0, _dentalProductApi.bindProductToDistributors)(data).then(function () {
        _this17.$message.success('绑定分销商成功');
        _this17.getList();
      }).catch(function (error) {
        _this17.$message.error('绑定分销商失败: ' + error.message);
      });
    },
    // 上传图片 - 使用Windows本地文件目录的方式，调用API接口
    modalPicTap: function modalPicTap() {
      // 创建一个隐藏的文件输入框
      var input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.accept = 'image/*'; // 只接受图片类型

      var _this = this;

      // 处理文件选择事件
      input.onchange = function (e) {
        var files = e.target.files;
        if (!files || !files.length) {
          return;
        }

        // 限制最多上传5张主图
        var maxCount = 5;
        var remainingSlots = maxCount - _this.productForm.imageList.length;
        var selectedFiles = Array.from(files).slice(0, remainingSlots);
        if (files.length > remainingSlots) {
          _this.$message.warning("\u6700\u591A\u9009\u62E9".concat(maxCount, "\u5F20\u4E3B\u56FE\uFF01\u5DF2\u81EA\u52A8\u9009\u62E9\u524D").concat(remainingSlots, "\u5F20"));
        }

        // 显示上传中的loading状态
        var loadingInstance = _this.$loading({
          lock: true,
          text: '图片上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 记录上传成功的数量
        var successCount = 0;
        // 记录上传的总数
        var totalCount = selectedFiles.length;
        // 记录是否已经显示了loading
        var isLoadingClosed = false;

        // 处理每个文件
        selectedFiles.forEach(function (file) {
          // 验证文件类型
          if (!file.type.startsWith('image/')) {
            _this.$message.error('请选择图片文件！');
            totalCount--;
            if (totalCount === 0) {
              loadingInstance.close();
              isLoadingClosed = true;
            }
            return;
          }

          // 创建FormData对象用于上传
          var formData = new FormData();
          formData.append('multipart', file);

          // 设置上传参数 - 调用指定的接口
          var params = {
            model: 'product',
            // 使用product模块
            pid: 1 // 使用指定的pid
          };

          // 调用API上传图片 - 使用指定的接口 http://localhost:8082/api/admin/upload/image?model=product&pid=1
          (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
            if (response && response.url) {
              // 上传成功，添加到图片列表
              _this.productForm.imageList.push(response.url);
              successCount++;
              console.log('图片上传成功，URL:', response.url);

              // 更新UI
              _this.$nextTick(function () {
                _this.$forceUpdate();
              });
            } else {
              _this.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: \u670D\u52A1\u5668\u8FD4\u56DE\u9519\u8BEF"));
            }
          }).catch(function (error) {
            console.error('Upload error:', error);
            _this.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: ").concat(error.message || '未知错误'));
          }).finally(function () {
            // 当所有文件都处理完毕后关闭loading状态并显示结果
            if (! --totalCount && !isLoadingClosed) {
              loadingInstance.close();
              isLoadingClosed = true;
              if (successCount > 0) {
                _this.$message.success("\u6210\u529F\u4E0A\u4F20".concat(successCount, "\u5F20\u56FE\u7247"));
              } else {
                // _this.$message.warning('没有图片上传成功');
              }
            }
          });
        });
      };

      // 触发文件选择对话框
      input.click();
    },
    // 处理商品详情
    handleViewDetail: function handleViewDetail(row) {
      this.currentProductId = row.id;
      this.detailDialogVisible = true;
      // 直接使用列表中的数据，不再调用API
      this.detailData = _objectSpread({}, row);

      // 确保description字段被正确处理
      this.detailData.description = this.detailData.description || '';

      // 确保图片列表是数组
      if (typeof this.detailData.imageList === 'string') {
        this.detailData.imageList = this.detailData.imageList.split(',').filter(function (url) {
          return url && url.trim() !== '';
        });
      } else if (!Array.isArray(this.detailData.imageList)) {
        this.detailData.imageList = [];
      }
      // 确保标签列表是数组
      if (typeof this.detailData.tagList === 'string') {
        this.detailData.tagList = this.detailData.tagList.split(',').filter(function (tag) {
          return tag && tag.trim() !== '';
        });
      } else if (!Array.isArray(this.detailData.tagList)) {
        this.detailData.tagList = [];
      }
      // 确保客户ID列表是数组
      if (typeof this.detailData.customerIdList === 'string') {
        this.detailData.customerIdList = this.detailData.customerIdList.split(',').map(function (id) {
          return Number(id);
        }).filter(function (id) {
          return !isNaN(id);
        });
      } else if (!Array.isArray(this.detailData.customerIdList)) {
        this.detailData.customerIdList = [];
      }

      // 确保状态字段有默认值
      if (this.detailData.status === null || this.detailData.status === undefined) {
        this.detailData.status = 0;
      }
      if (this.detailData.syncStatus === null || this.detailData.syncStatus === undefined) {
        this.detailData.syncStatus = 0;
      }

      // 保存描述信息，以便在编辑时使用
      this.savedDescription = this.detailData.description;
    },
    // 此方法已由handleImagePreview代替
    previewDetailImage: function previewDetailImage(index) {
      this.handleImagePreview(this.detailData.imageList, index);
    },
    // 处理描述内容变更
    handleDescriptionChange: function handleDescriptionChange(content) {
      this.savedDescription = content;
      this.productForm.description = content;
    },
    // Add this new method to handle view mode change
    handleViewModeChange: function handleViewModeChange(mode) {
      this.viewMode = mode;
      localStorage.setItem('dentalProductViewMode', mode);
    },
    clearKeyword: function clearKeyword() {
      this.searchForm.keyword = '';
      this.getList();
    },
    clearSupplier: function clearSupplier() {
      this.searchForm.supplierId = '';
      this.getList();
    },
    clearStatus: function clearStatus() {
      this.searchForm.status = '';
      this.getList();
    },
    getSupplierName: function getSupplierName(id) {
      var supplier = this.supplierOptions.find(function (item) {
        return item.id === id;
      });
      return supplier ? supplier.supplierName : '';
    },
    handleImagePreview: function handleImagePreview(imageList) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (imageList && imageList.length > 0) {
        // 使用自定义预览组件
        this.previewConfig = {
          visible: true,
          urlList: Array.isArray(imageList) ? imageList : [imageList],
          index: index
        };
      }
    }
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑套餐商品' : '新增套餐商品';
    },
    hasActiveFilters: function hasActiveFilters() {
      return this.searchForm.keyword || this.searchForm.supplierId || this.searchForm.status !== '';
    }
  }
};